/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The StringStringValuesKeyValuePair model module.
 * @module model/StringStringValuesKeyValuePair
 * @version V1
 */
class StringStringValuesKeyValuePair {
    /**
     * Constructs a new <code>StringStringValuesKeyValuePair</code>.
     * @alias module:model/StringStringValuesKeyValuePair
     */
    constructor() { 
        
        StringStringValuesKeyValuePair.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>StringStringValuesKeyValuePair</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/StringStringValuesKeyValuePair} obj Optional instance to populate.
     * @return {module:model/StringStringValuesKeyValuePair} The populated <code>StringStringValuesKeyValuePair</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new StringStringValuesKeyValuePair();

            if (data.hasOwnProperty('key')) {
                obj['key'] = ApiClient.convertToType(data['key'], 'String');
            }
            if (data.hasOwnProperty('value')) {
                obj['value'] = ApiClient.convertToType(data['value'], ['String']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>StringStringValuesKeyValuePair</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>StringStringValuesKeyValuePair</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['key'] && !(typeof data['key'] === 'string' || data['key'] instanceof String)) {
            throw new Error("Expected the field `key` to be a primitive type in the JSON string but got " + data['key']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['value'])) {
            throw new Error("Expected the field `value` to be an array in the JSON data but got " + data['value']);
        }

        return true;
    }


}



/**
 * @member {String} key
 */
StringStringValuesKeyValuePair.prototype['key'] = undefined;

/**
 * @member {Array.<String>} value
 */
StringStringValuesKeyValuePair.prototype['value'] = undefined;






export default StringStringValuesKeyValuePair;

